// extVersions.actionTypes.js
export const SET_LOADING = "SET_LOADING";
export const SET_DOWNLOADING = "SET_DOWNLOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_OPEN_MODAL = "SET_OPEN_MODAL";
export const SET_EXT_VERSION = "SET_EXT_VERSION";
export const RESET_EXT_VERSION = "RESET_EXT_VERSION";
export const SET_SINGLE_VERSION_LOADING = "SET_SINGLE_VERSION_LOADING";

export const GET_EXT_VERSIONS = "GET_EXT_VERSIONS";
export const GET_EXT_VERSIONS_SUCCESS = "GET_EXT_VERSIONS_SUCCESS";
export const GET_EXT_VERSIONS_FAILURE = "GET_EXT_VERSIONS_FAILURE";

export const GET_EXT_VERSION = "GET_EXT_VERSION";
export const GET_EXT_VERSION_SUCCESS = "GET_EXT_VERSION_SUCCESS";
export const GET_EXT_VERSION_FAILURE = "GET_EXT_VERSION_FAILURE";

export const CREATE_EXT_VERSION = "CREATE_EXT_VERSION";
export const CREATE_EXT_VERSION_SUCCESS = "CREATE_EXT_VERSION_SUCCESS";
export const CREATE_EXT_VERSION_FAILURE = "CREATE_EXT_VERSION_FAILURE";

export const RETRIGGER_EXT_VERSION = "RETRIGGER_EXT_VERSION";
export const RETRIGGER_EXT_VERSION_SUCCESS = "RETRIGGER_EXT_VERSION_SUCCESS";
export const RETRIGGER_EXT_VERSION_FAILURE = "RETRIGGER_EXT_VERSION_FAILURE";

export const RETRY_EXT_VERSION_OUTPUT = 'RETRY_EXT_VERSION_OUTPUT';
export const RETRY_EXT_VERSION_OUTPUT_REQUEST = 'RETRY_EXT_VERSION_OUTPUT_REQUEST';
export const RETRY_EXT_VERSION_OUTPUT_SUCCESS = 'RETRY_EXT_VERSION_OUTPUT_SUCCESS';
export const RETRY_EXT_VERSION_OUTPUT_FAILURE = 'RETRY_EXT_VERSION_OUTPUT_FAILURE';

export const UPDATE_EXT_VERSION = "UPDATE_EXT_VERSION";
export const UPDATE_EXT_VERSION_SUCCESS = "UPDATE_EXT_VERSION_SUCCESS";
export const UPDATE_EXT_VERSION_FAILURE = "UPDATE_EXT_VERSION_FAILURE";

export const DELETE_EXT_VERSION = "DELETE_EXT_VERSION";
export const DELETE_EXT_VERSION_SUCCESS = "DELETE_EXT_VERSION_SUCCESS";
export const DELETE_EXT_VERSION_FAILURE = "DELETE_EXT_VERSION_FAILURE";

export const UPDATE_EXT_VERSIONS_ORDER = "UPDATE_EXT_VERSIONS_ORDER";
export const UPDATE_EXT_VERSIONS_ORDER_SUCCESS = "UPDATE_EXT_VERSIONS_ORDER_SUCCESS";
export const UPDATE_EXT_VERSIONS_ORDER_FAILURE = "UPDATE_EXT_VERSIONS_ORDER_FAILURE";

export const GET_EXT_VERSION_BY_KEY = "GET_EXT_VERSION_BY_KEY";
export const GET_EXT_VERSION_BY_KEY_SUCCESS = "GET_EXT_VERSION_BY_KEY_SUCCESS";
export const GET_EXT_VERSION_BY_KEY_FAILURE = "GET_EXT_VERSION_BY_KEY_FAILURE";

export const START_POLLING_EXT_VERSION_OUTPUT = "START_POLLING_EXT_VERSION_OUTPUT";
export const STOP_POLLING_EXT_VERSION_OUTPUT = "STOP_POLLING_EXT_VERSION_OUTPUT";
export const STOP_ALL_POLLING_EXT_VERSION_OUTPUT = "STOP_ALL_POLLING_EXT_VERSION_OUTPUT";
export const POLLING_EXT_VERSION_OUTPUT_ERROR = "POLLING_EXT_VERSION_OUTPUT_ERROR";

export const DOWNLOAD_EXT_VERSION_CSV = "DOWNLOAD_EXT_VERSION_CSV";
export const DOWNLOAD_EXT_VERSION_CSV_SUCCESS = "DOWNLOAD_EXT_VERSION_CSV_SUCCESS";
export const DOWNLOAD_EXT_VERSION_CSV_FAILURE = "DOWNLOAD_EXT_VERSION_CSV_FAILURE";

export const BATCH_STATUS_CHECK         = 'BATCH_STATUS_CHECK';
export const BATCH_STATUS_CHECK_SUCCESS = 'BATCH_STATUS_CHECK_SUCCESS';
export const BATCH_STATUS_CHECK_FAILURE = 'BATCH_STATUS_CHECK_FAILURE';

export const INITIATE_DRAFT_SESSION = "INITIATE_DRAFT_SESSION";
// export const INITIATE_DRAFT_SESSION_LOADING = "INITIATE_DRAFT_SESSION_LOADING";
export const INITIATE_DRAFT_SESSION_SUCCESS = "INITIATE_DRAFT_SESSION_SUCCESS";
export const INITIATE_DRAFT_SESSION_FAILURE = "INITIATE_DRAFT_SESSION_FAILURE";

export const RECALCULATE_EXT_VERSION = "RECALCULATE_EXT_VERSION";
export const RECALCULATE_EXT_VERSION_SUCCESS = "RECALCULATE_EXT_VERSION_SUCCESS";
export const RECALCULATE_EXT_VERSION_FAILURE = "RECALCULATE_EXT_VERSION_FAILURE";